import { ParameterError } from './errors';
/**
 * Connector registry. Adding connector #3..#70 is a new member here plus rows in
 * the connector tables — not a new model, service, or migration.
 */
export var ConnectorType;
(function (ConnectorType) {
    ConnectorType["GITHUB"] = "github";
    ConnectorType["HUBSPOT_DEALS"] = "hubspot_deals";
    ConnectorType["ZENDESK"] = "zendesk";
    ConnectorType["AIRTABLE"] = "airtable";
    ConnectorType["CHARGEBEE"] = "chargebee";
    ConnectorType["FRESHDESK"] = "freshdesk";
    ConnectorType["GITLAB"] = "gitlab";
    ConnectorType["INTERCOM"] = "intercom";
    ConnectorType["JIRA"] = "jira";
    ConnectorType["NOTION"] = "notion";
    ConnectorType["RAZORPAY"] = "razorpay";
    ConnectorType["SHOPIFY"] = "shopify";
    ConnectorType["STRIPE"] = "stripe";
    ConnectorType["PAGERDUTY"] = "pagerduty";
    ConnectorType["KLAVIYO"] = "klaviyo";
    ConnectorType["PIPEDRIVE"] = "pipedrive";
    ConnectorType["FRONT"] = "front";
    ConnectorType["HELP_SCOUT"] = "help_scout";
    ConnectorType["ASANA"] = "asana";
    ConnectorType["CLICKUP"] = "clickup";
    ConnectorType["BAMBOOHR"] = "bamboohr";
    ConnectorType["GREENHOUSE"] = "greenhouse";
    ConnectorType["LEVER"] = "lever";
    ConnectorType["TYPEFORM"] = "typeform";
    ConnectorType["POSTHOG"] = "posthog";
    ConnectorType["GOOGLE_DRIVE"] = "google_drive";
    ConnectorType["GOOGLE_WORKSPACE_DIRECTORY"] = "google_workspace_directory";
    ConnectorType["SALESFORCE"] = "salesforce";
    ConnectorType["SLACK"] = "slack";
    ConnectorType["MICROSOFT_GRAPH"] = "microsoft_graph";
    ConnectorType["XERO"] = "xero";
    ConnectorType["ZOHO_CRM"] = "zoho_crm";
    ConnectorType["CALENDLY"] = "calendly";
    ConnectorType["MAILCHIMP"] = "mailchimp";
    ConnectorType["META_ADS"] = "meta_ads";
    ConnectorType["CONFLUENCE"] = "confluence";
    ConnectorType["TWILIO"] = "twilio";
    ConnectorType["RECURLY"] = "recurly";
    ConnectorType["GOCARDLESS"] = "gocardless";
    ConnectorType["SQUARE"] = "square";
    ConnectorType["HIBOB"] = "hibob";
    ConnectorType["TRELLO"] = "trello";
    ConnectorType["WRIKE"] = "wrike";
    ConnectorType["SMARTSHEET"] = "smartsheet";
    ConnectorType["ROLLBAR"] = "rollbar";
    ConnectorType["STATUSPAGE"] = "statuspage";
    ConnectorType["SURVEYMONKEY"] = "surveymonkey";
    ConnectorType["DELIGHTED"] = "delighted";
    ConnectorType["CLOSE"] = "close";
    ConnectorType["FRESHSALES"] = "freshsales";
    ConnectorType["FRESHSERVICE"] = "freshservice";
    ConnectorType["AIRCALL"] = "aircall";
    ConnectorType["POSTMARK"] = "postmark";
    ConnectorType["BREVO"] = "brevo";
    ConnectorType["OUTREACH"] = "outreach";
    ConnectorType["SALESLOFT"] = "salesloft";
    ConnectorType["ADYEN"] = "adyen";
    ConnectorType["LINKEDIN_ADS"] = "linkedin_ads";
    ConnectorType["SEGMENT"] = "segment";
    ConnectorType["DOCUSIGN"] = "docusign";
    ConnectorType["ZOOM"] = "zoom";
    ConnectorType["DATADOG"] = "datadog";
    ConnectorType["RIPPLING"] = "rippling";
    ConnectorType["PERSONIO"] = "personio";
    ConnectorType["DEEL"] = "deel";
    ConnectorType["GUSTO"] = "gusto";
    ConnectorType["BITBUCKET"] = "bitbucket";
    ConnectorType["ZOHO_BOOKS"] = "zoho_books";
    ConnectorType["GMAIL"] = "gmail";
    ConnectorType["GOOGLE_CALENDAR"] = "google_calendar";
    ConnectorType["GOOGLE_SHEETS"] = "google_sheets";
    ConnectorType["GOOGLE_DOCS"] = "google_docs";
})(ConnectorType || (ConnectorType = {}));
/**
 * Terminal statuses as an `as const` tuple so the model can spread it into
 * `.whereNotIn('status', TERMINAL)` and the predicate below derives from it.
 */
export const CONNECTOR_TERMINAL_SYNC_STATUSES = [
    'succeeded',
    'failed',
];
/** Matches the migration's partial unique index for one active run per connector. */
export const CONNECTOR_ACTIVE_SYNC_STATUSES = ['queued', 'running'];
export const isConnectorSyncInProgress = (status) => !CONNECTOR_TERMINAL_SYNC_STATUSES.includes(status);
/**
 * Postgres identifier rules for the destination schema, which is the per-tenant
 * boundary. Anything outside this set is rejected before it can reach SQL.
 */
const TARGET_SCHEMA_PATTERN = /^[a-z][a-z0-9_]{2,62}$/;
export const isValidConnectorTargetSchema = (value) => TARGET_SCHEMA_PATTERN.test(value);
export function assertConnectorTargetSchema(value) {
    if (!isValidConnectorTargetSchema(value)) {
        throw new ParameterError('Target schema must be 3-63 characters, start with a lowercase letter, and contain only lowercase letters, digits, and underscores');
    }
    return value;
}
//# sourceMappingURL=connector.js.map